// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ae9767e0","337":"71f546c0","453":"19a7c741","455":"37478be0"}[chunkId] + ".chunk.js";
};